import { ProductAvailabilityTemplateCreatePage } from '@/features/product-availability-template/pages/ProductAvailabilityTemplateCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/admin/product-availability-template/create',
)({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_availability_template.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductAvailabilityTemplateCreatePage,
})
